import { cn } from "@onclicks/sharedcomponents/ui";
import * as React from "react";

const Input: React.FC<
  {
    ref?: React.Ref<HTMLInputElement>;
  } & React.InputHTMLAttributes<HTMLInputElement>
> = ({ type, className, ref, ...props }) => {
  return (
    <input
      className={cn(
        "bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring border-1 flex h-10 w-full rounded border border-gray-200 px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      ref={ref}
      type={type}
      {...props}
    />
  );
};

export { Input };
